var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boton_comentarios",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34.168,
    viewBox: "0 0 34 34.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 34,
    height: 34,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 34,
    height: 34,
    transform: "translate(1246 704)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    fill: "#fff",
    stroke: "#8eae41",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 4,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "comentarios",
    transform: "translate(0 0.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_56",
    "data-name": "Mask Group 56",
    transform: "translate(-1246 -704)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_comment-alt_",
    "data-name": "FontAwsome (comment-alt)",
    d: "M15.67,0H2.239A2.241,2.241,0,0,0,0,2.239V12.312A2.241,2.241,0,0,0,2.239,14.55H5.6v2.938a.419.419,0,0,0,.42.42.4.4,0,0,0,.248-.084l4.369-3.274H15.67a2.241,2.241,0,0,0,2.239-2.239V2.239A2.241,2.241,0,0,0,15.67,0Zm.56,12.312a.561.561,0,0,1-.56.56h-5.6l-.448.336L7.275,14.97v-2.1H2.239a.561.561,0,0,1-.56-.56V2.239a.561.561,0,0,1,.56-.56H15.67a.561.561,0,0,1,.56.56Z",
    transform: "translate(1254.047 713.047)",
    fill: "#b1cb79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComments);
export default __webpack_public_path__ + "static/media/icon_comments.23699ee57a13ed954fd6c4fff638fbd4.svg";
export { ForwardRef as ReactComponent };